import _objectSpread from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["faction", "factionId"];
import { jsx, Fragment } from 'react/jsx-runtime';
import { forwardRef, useMemo } from 'react';
import { FactionIdToName } from '../../warzone/utils.js';
import { Amarr } from './Amarr.js';
import { Caldari } from './Caldari.js';
import { Gallente } from './Gallente.js';
import { Minmatar } from './Minmatar.js';
import { Angel } from './Angel.js';
import { Guristas } from './Guristas.js';
var AvailableFactionLogos = {
  amarr: Amarr,
  caldari: Caldari,
  gallente: Gallente,
  guristas: Guristas,
  minmatar: Minmatar,
  angel: Angel
};
var GetLogoForFaction = function GetLogoForFaction(faction) {
  return AvailableFactionLogos[faction];
};
var FactionLogo = forwardRef(function (_ref, ref) {
  var faction = _ref.faction,
    factionId = _ref.factionId,
    rest = _objectWithoutProperties(_ref, _excluded);
  var Logo = useMemo(function () {
    return GetLogoForFaction(faction || FactionIdToName(factionId));
  }, [faction, factionId]);
  return Logo ? /* @__PURE__ */jsx(Logo, _objectSpread({
    ref: ref
  }, rest)) : /* @__PURE__ */jsx(Fragment, {});
});
FactionLogo.displayName = "FactionLogo";
export { FactionLogo, GetLogoForFaction };